module.exports = __webpack_public_path__ + "static/media/calendar_icon_red.0f8e1acb.svg";